import { createAsyncThunk } from '@reduxjs/toolkit';
import { toApiError } from 'shared/errors';
import { DeviceDto } from 'modules/core/supabase/tables/device';
import devicesRepository from '../domain/repositories/devices-repository';

const PREFIX = 'devices';

export const createDevice = createAsyncThunk<DeviceDto, { name: string; tournament_id: number }>(
  `${PREFIX}/createDevice`,
  async (payload, { rejectWithValue }) => {
    try {
      return await devicesRepository.create(payload);
    } catch (error) {
      console.error(`${PREFIX}/createDevice error:`, error);
      return rejectWithValue(toApiError(error));
    }
  },
);

export const updateDevice = createAsyncThunk<DeviceDto, { id: number; params: Partial<{ name: string; tournament_id: number }> }>(
  `${PREFIX}/updateDevice`,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      return await devicesRepository.update(id, params);
    } catch (error) {
      console.error(`${PREFIX}/updateDevice error:`, error);
      return rejectWithValue(toApiError(error));
    }
  },
);

export const deleteDevice = createAsyncThunk<boolean, number>(`${PREFIX}/deleteDevice`, async (id, { rejectWithValue }) => {
  try {
    return await devicesRepository.delete(id);
  } catch (error) {
    console.error(`${PREFIX}/deleteDevice error:`, error);
    return rejectWithValue(toApiError(error));
  }
});
